<template>
 <div>
    <span style="margin-left: 15px">{{ $t("MML.neCfgRestoreConfirmTip") }}</span>
  </div>
</template>

<script>
export default {
  name: "RestoreConfirm",
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

